import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["rows"]

import { useVModel } from '@vueuse/core';
import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'VTextarea',
  props: {
    modelValue: null
  },
  emits: ['update:modelValue'],
  setup(__props: any, { emit }) {

const props = __props as { modelValue?: string }

const rows = ref(1)
const calcHeight = (e: Event) => {
  const textarea = e.target as HTMLTextAreaElement
  textarea.style.height = "0px"
  rows.value = Math.round((textarea.scrollHeight-28) / 18)
  textarea.style.height = ""
}



const model = useVModel(props, 'modelValue', emit)


return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("textarea", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
    class: "scroll",
    rows: rows.value,
    onInput: calcHeight
  }, null, 40, _hoisted_1)), [
    [_vModelText, _unref(model)]
  ])
}
}

})